import state from "./state";

export default {
  changeMinivariantStatus() {
    state.minivariant = !state.minivariant;
  }
};
